<template>
  <div class="stance" @click="selected" :class="{'selected' : isActive(stance)}" v-b-tooltip.hover
       :title="stanceTooltip">
    <div class="stance-button p-1">
      <div class="button-icon pt-2">
        <img loading="lazy" sizes="100%, 100%" v-show="show" :src="styleUrl" :title="ucFirst(stance.attack_type)"
             :alt="ucFirst(stance.combat_style)"
             class="stance-image img-fluid">
        <img loading="lazy" sizes="100%, 100%" v-if="isMagicStance" :src="spellUrl" :title="ucFirst(stance.attack_type)"
             :alt="ucFirst(stance.combat_style)"
             class="stance-image img-fluid spell-image">
      </div>
      <div class="button-text pt-1">
        <div class="text-center stance-text ">{{ucFirst(stance.combat_style)}}</div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "Stance",
    props: {
      stance: {
        type: Object,
        default: function () {
          return {
            combat_style: "flick",
            attack_type: "slash",
            attack_style: "accurate",
            experience: "attack",
            boosts: null
          }
        }
      },
      activeSpell: {
        type: Object,
        default() {
          return null
        }
      },
      activeStance: {
        type: Object,
      }
    },
    computed: {
      stanceTooltip: function () {
        if(this.stance.attack_style === null) {
          return  `Increase ${this.stance.boosts}`
        }

        return `${this.ucHuman(this.stance.attack_style)} - ${this.ucHuman(this.stance.attack_type)}`;
      },

      isMagicStance: function () {
        return this.stance.attack_style === 'magic'
      },
      /**
       * Hide the first icon if its a spell so it doesnt duplicate with the spellUrl
       * @returns {boolean}
       */
      show: function () {
        if (this.stance.combat_style === 'spell')
          return false;

        return true;
      },
      spellUrl: function () {
        if (this.isMagicStance && this.activeSpell !== null) {
          return this.activeSpell.image;
        }

        return '/static/images/icons/styles/style_spell.png'
      },
      styleUrl: function () {
        if (this.stance === null)
          return '';

        let combatTidy = this.stance.combat_style.replace(/ /g, '_').replace('(', '').replace(')', '');

        return `/static/images/icons/styles/style_${combatTidy}.png`;
      },
    },
    methods: {
      selected: function () {
        // console.log('new stance selected', this.stance);
        this.$emit('selected', this.stance)
      },

      isActive: function (s) {
        // console.log('isActive', [s, this.activeStance]);
        return s.combat_style === this.activeStance.combat_style
      }
    }
  }
</script>

<style scoped>
  .stance {
    border-radius: 4px;
    min-height: 40px;
    background: grey;
    cursor: pointer;
  }

  .stance.selected {
    background: #821F1C;
  }

  .stance-text {
    color: black;
    font-weight: bold;
    font-size: 0.8rem;
  }

  .button-icon {
    width: 100%;
    position: relative;
    float: left;
    display: inline-block;
  }

  .button-text {
    position: relative;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/Stance.vue